import * as React from "react";
import classnames from "classnames";

import { Division } from "../../../../models/Division";
import { Getter, DataGrid } from "../../../../components/DataGrid/DataGrid";
import { ColumnProps } from "../../../../components/DataGrid/CellColumnProps";
import { IdColumn } from "../Columns/IdColumn";
import { DataGridTextColumn } from "../../../../components/DataGrid/DataGridTextColumn";
import { DataGridTemplateColumn, Props as TemplateProps } from "../../../../components/DataGrid/DataGridTemplateColumn";
import { Button } from "../../../../components/Buttons";
import { Polyglot } from "../../../../polyglot";

const styles = require('./DivisionGrid.scss');

const getName: Getter<Division> = v => v.Name;

interface Props extends ColumnProps
{
    polyglot: Polyglot;
    items: Division[];

    switchTo: (datum: any, row: number) => void;
    onEdit: (datum: any, row: number) => void;
}

interface NameCellProps
{
    polyglot: Polyglot;
    switchTo: (datum: any, row: number) => void;
}

const AdminIcon = (props: {title: string}) => <span className={classnames(styles.AdminIcon, 'glyphicon glyphicon-user')} {...props} />;
const NameCell = (props: TemplateProps & NameCellProps) =>
{
    const { datum, row, getValue, switchTo } = props;
    const division = datum as Division;
    return (
        <td className={styles.NameCell}>
            <span>{division.IsAdmin && <AdminIcon title={props.polyglot.t('division.msg_admin_for', { name: division.Name})}/>}{getValue(datum)}</span>
            <Button dim="xs" type="info" leftIcon="transfer" onClick={e => switchTo(datum, row)}>{props.polyglot.t('division.btn_switch')}</Button>
        </td>
    );
}

// This is a grid component which is displayed on Division tab
export const DivisionGrid = (props: Props) => (
    <DataGrid initialData={props.items} className={props.className} onThead={props.onThead}>
        <IdColumn header={props.polyglot.t('column.id')} />
        <DataGridTemplateColumn header={props.polyglot.t('division.name_label')} getValue={getName} render={(colProps: TemplateProps) => (
            <NameCell switchTo={props.switchTo} polyglot={props.polyglot} {...colProps}/>
        )} />

        <DataGridTemplateColumn header={props.polyglot.t('column.action')} render={ p => {
            const { datum, row } = p;
            const isReadonly = typeof (datum as Division).ParentId !== 'number' || !(datum as Division).IsAdmin;

            return (
                <td className='btn-toolbar'>
                    <Button dim="xs" leftIcon="pencil" type="info" onClick={e => props.onEdit(datum, row)} disabled={isReadonly}>{props.polyglot.t('button.edit_short')}</Button>
                </td>
            );
        }}
        />
    </DataGrid>
);


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/DivisionGrid.tsx